import React from 'react';
import PropTypes from 'prop-types';

import BodyContentStyles from './BodyContent.styled';

import Markdown from '../../Shared/Markdown/Markdown';
import Image from 'next/image';

export const MediaPostion = {
  Left: 1,
  Right: 2,
  Top: 3,
  Bottom: 4,
};

const BodyContent = ({
  backgroundColor = '#FFFFFF',
  disclaimer,
  markdown,
  media,
  mediaPostion = MediaPostion.Left,
}) => {
  let mediaPositionClass = '';

  if (media) {
    switch (mediaPostion) {
      case MediaPostion.Left:
        mediaPositionClass = 'media-left';
        break;

      case MediaPostion.Right:
        mediaPositionClass = 'media-right';
        break;

      case MediaPostion.Top:
        mediaPositionClass = 'media-top';
        break;

      case MediaPostion.Bottom:
        mediaPositionClass = 'media-bottom';
        break;
    }
  }

  return (
    <BodyContentStyles
      backgroundColor={backgroundColor}
      className={`body-content ${mediaPositionClass} ${media ? 'media' : ''}`}
    >
      <div className="body-content-container">
        {media ? <Image src={media} alt="Content Media" fill /> : null}
        <div className="body-content-text">
          {/* Header doesn't appear to be used in the calls to this component. If we need it, use a header from smokey library. */}
          {/* { header ?
                        <Heading headingText={header} headingTag="h1" /> : null } */}
          <Markdown markdown={markdown.replace(/w=780/g, 'w=800')} />
          {disclaimer ? <p className="disclaimer">{disclaimer}</p> : null}
        </div>
      </div>
    </BodyContentStyles>
  );
};

BodyContent.propTypes = {
  backgroundColor: PropTypes.string,
  disclaimer: PropTypes.string,
  markdown: PropTypes.string,
  media: PropTypes.string,
  mediaPostion: PropTypes.number,
};

export default BodyContent;
